import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  (theme) => ({
    guestRow: {
      justifyContent: 'space-between',
      maxWidth: '100%',
    },
    guestName: {
      width: '150px',
      flexShrink: 0,
    },
    guestAllergies: {
      flexGrow: 1,
      fontSize: '15px',
    },
    allergyPills: {
      // flexShrink: 0,
      flexWrap: 'wrap',
      // maxWidth: '100%',
    },
    allergyPill: {
      // border: `1px solid ${theme.colors.outlineColour}`,
      // borderRadius: '30px',
      // padding: '5px 13px',
    },
  }),
  { name: 'DietariesSummary' },
);

export default useStyles;
